// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;

  }
}

body {
  padding-right: 0px !important;
}

/* Oculta el sidenav en vistas públicas (Home y Login) desde el primer pintado */
body.home-page #root,
body.login-page #root,
body.public-reportes-page #root {
  margin-left: 0 !important;
}

body.home-page aside,
body.home-page .sidenav---sidenav---_2tBP,
body.login-page aside,
body.login-page .sidenav---sidenav---_2tBP,
body.public-reportes-page aside,
body.public-reportes-page .sidenav---sidenav---_2tBP {
  display: none !important;
}


.modal-xxl {
  max-width: 90%; /* Ajusta según lo que necesites */
}


/* Custom class swal buttons */
.custom-confirm-button {
  background-color: #006699;
  border: none;
  color: white;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
}

.custom-cancel-button {
  background-color: red;
  border: none;
  color: white;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.LabelLogo {
  font-size: 28px;
  font-style: italic;
  color: #2EA4B1;
  font-family: 'Rockwell Extra Bold';

}

.LabelBarra {
  position: relative;
  font-size: 16px;
  left: 20px;
  font-style: italic;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

#root {
  margin-left: 65px;
  overflow-x: hidden;
}





aside {
  height: 100vh;
  position: fixed;
  z-index: 9998;
}

.modal {
  z-index: 10001;
}

.swal2-container {
  z-index: 10000 !important;
}



#layout-navbar {
  background-color: transparent;
}

.cardContainerTrafico2 {
  display: none;
}

.cardControlHistoricoResponsive {
  display: none;
}



/* Repsonsive */
@media (max-width: 1024px) {
  #root {
    overflow-x: hidden;
  }

  #table {
    overflow-x: hidden;
  }

  .table-responsive {
    width: 1290px;

  }

  #layout-navbar {
    flex-wrap: wrap;
  }

  #avtarIcon {
    transform: translateY(-55px);
  }

  .label_trafico {
    margin-top: 50px;
  }

  .cardContainerTrafico {
    width: 100%;
    overflow-x: auto;
  }

  .cardControlHistorico {
    width: 100%;
    overflow-x: auto;
  }

  .table thead th {
    white-space: wrap;
  }

  .table tbody td {
    white-space: wrap;
  }

  .offcanvas {
    z-index: 9999;
  }

  .cardControlHistorico {
    display: none;
  }

  .cardControlHistoricoResponsive {
    display: inline;
  }

  .containerCardsHistoricos {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 24px;
  }

  .containerContratoHistoricoInitial {
    padding: 12px;
  }

  .containerContratoHistoricoInitial span {
    font-weight: 700;
  }

  .cardContainerControlDevice {
    width: 100%;
    overflow-x: auto;
  }

}

@media (max-width: 768px) {

  #root {
    overflow-x: hidden;
  }

  #table {
    overflow-x: hidden;
  }

  .table-responsive {
    width: 1290px;

  }

  #layout-navbar {
    flex-wrap: wrap;
  }

  #avtarIcon {
    transform: translateY(-55px);
  }

  .label_trafico {
    margin-top: 50px;
  }

  .cardContainerTrafico {
    width: 100%;
    overflow-x: auto;
  }

  .table thead th {
    white-space: wrap;
  }

  .table tbody td {
    white-space: wrap;
  }

  .offcanvas {
    z-index: 9999;
  }

  .cardContainerTrafico {
    display: none;
  }

  .cardContainerTrafico2 {
    display: inline;
  }

  .cardControlHistorico {
    display: none;
  }

  .cardControlHistoricoResponsive {
    display: inline;
  }

  .containerCardsHistoricos {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 24px;
  }


}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;;EAE9C;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,gFAAgF;AAChF;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;;AAGA;EACE,cAAc,EAAE,kCAAkC;AACpD;;;AAGA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kCAAkC;;AAEpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;;;;;AAMA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;;;AAIA,eAAe;AACf;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;;EAEf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;AAEF;;AAEA;;EAEE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;;EAEf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;;AAGF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n\n  }\n}\n\nbody {\n  padding-right: 0px !important;\n}\n\n/* Oculta el sidenav en vistas públicas (Home y Login) desde el primer pintado */\nbody.home-page #root,\nbody.login-page #root,\nbody.public-reportes-page #root {\n  margin-left: 0 !important;\n}\n\nbody.home-page aside,\nbody.home-page .sidenav---sidenav---_2tBP,\nbody.login-page aside,\nbody.login-page .sidenav---sidenav---_2tBP,\nbody.public-reportes-page aside,\nbody.public-reportes-page .sidenav---sidenav---_2tBP {\n  display: none !important;\n}\n\n\n.modal-xxl {\n  max-width: 90%; /* Ajusta según lo que necesites */\n}\n\n\n/* Custom class swal buttons */\n.custom-confirm-button {\n  background-color: #006699;\n  border: none;\n  color: white;\n  padding: 10px 20px;\n  font-size: 16px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.custom-cancel-button {\n  background-color: red;\n  border: none;\n  color: white;\n  padding: 10px 20px;\n  font-size: 16px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.LabelLogo {\n  font-size: 28px;\n  font-style: italic;\n  color: #2EA4B1;\n  font-family: 'Rockwell Extra Bold';\n\n}\n\n.LabelBarra {\n  position: relative;\n  font-size: 16px;\n  left: 20px;\n  font-style: italic;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n#root {\n  margin-left: 65px;\n  overflow-x: hidden;\n}\n\n\n\n\n\naside {\n  height: 100vh;\n  position: fixed;\n  z-index: 9998;\n}\n\n.modal {\n  z-index: 10001;\n}\n\n.swal2-container {\n  z-index: 10000 !important;\n}\n\n\n\n#layout-navbar {\n  background-color: transparent;\n}\n\n.cardContainerTrafico2 {\n  display: none;\n}\n\n.cardControlHistoricoResponsive {\n  display: none;\n}\n\n\n\n/* Repsonsive */\n@media (max-width: 1024px) {\n  #root {\n    overflow-x: hidden;\n  }\n\n  #table {\n    overflow-x: hidden;\n  }\n\n  .table-responsive {\n    width: 1290px;\n\n  }\n\n  #layout-navbar {\n    flex-wrap: wrap;\n  }\n\n  #avtarIcon {\n    transform: translateY(-55px);\n  }\n\n  .label_trafico {\n    margin-top: 50px;\n  }\n\n  .cardContainerTrafico {\n    width: 100%;\n    overflow-x: auto;\n  }\n\n  .cardControlHistorico {\n    width: 100%;\n    overflow-x: auto;\n  }\n\n  .table thead th {\n    white-space: wrap;\n  }\n\n  .table tbody td {\n    white-space: wrap;\n  }\n\n  .offcanvas {\n    z-index: 9999;\n  }\n\n  .cardControlHistorico {\n    display: none;\n  }\n\n  .cardControlHistoricoResponsive {\n    display: inline;\n  }\n\n  .containerCardsHistoricos {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-top: 24px;\n  }\n\n  .containerContratoHistoricoInitial {\n    padding: 12px;\n  }\n\n  .containerContratoHistoricoInitial span {\n    font-weight: 700;\n  }\n\n  .cardContainerControlDevice {\n    width: 100%;\n    overflow-x: auto;\n  }\n\n}\n\n@media (max-width: 768px) {\n\n  #root {\n    overflow-x: hidden;\n  }\n\n  #table {\n    overflow-x: hidden;\n  }\n\n  .table-responsive {\n    width: 1290px;\n\n  }\n\n  #layout-navbar {\n    flex-wrap: wrap;\n  }\n\n  #avtarIcon {\n    transform: translateY(-55px);\n  }\n\n  .label_trafico {\n    margin-top: 50px;\n  }\n\n  .cardContainerTrafico {\n    width: 100%;\n    overflow-x: auto;\n  }\n\n  .table thead th {\n    white-space: wrap;\n  }\n\n  .table tbody td {\n    white-space: wrap;\n  }\n\n  .offcanvas {\n    z-index: 9999;\n  }\n\n  .cardContainerTrafico {\n    display: none;\n  }\n\n  .cardContainerTrafico2 {\n    display: inline;\n  }\n\n  .cardControlHistorico {\n    display: none;\n  }\n\n  .cardControlHistoricoResponsive {\n    display: inline;\n  }\n\n  .containerCardsHistoricos {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-top: 24px;\n  }\n\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
